import { cn } from "@moe/priv/utils";
import { useAppContext } from "@web/route-services/root/AppContext";
import { cva } from "class-variance-authority";

const avatarVariants = cva("shrink-0 select-none object-cover object-top", {
  variants: {
    size: {
      sm: "h-9 w-9",
      md: "h-12 w-12",
      lg: "h-16 w-16",
      xl: "h-20 w-20"
    },
    shape: {
      circle: "rounded-full",
      square: "rounded-md"
    }
  },
  defaultVariants: {
    size: "md",
    shape: "circle"
  }
});

interface Props {
  src?: string | null | URL;
  className?: string;
  [rest: string]: any;
}

export function CharacterMessageAvatar({ src, className, ...rest }: Props) {
  const { settings } = useAppContext();
  return (
    <img
      className={cn(
        avatarVariants({
          size: settings?.messageAvatarSize ?? "md",
          shape: settings?.messageAvatarShape ?? "circle"
        }),
        className
      )}
      draggable="false"
      src={src instanceof URL ? src.toString() : src || "/default_avatar.webp"}
      alt="Avatar"
      {...rest}
    />
  );
}
